<template>
  <v-container>
    <div class="breadcrumbs-wrap">
      <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
    </div>
    <h1 class="title-pg">{{ $t('Нормативы пользования') }}</h1>
    <div class="my-organization">
      <div class="quotas-pg bgw-pdg-20">
        <div class="flex-two-col">
          <div class="flex-two-col__left">
            <Menu/>
          </div>
        </div>
        <div class="flex-two-col">
          <div class="flex-two-col__left">
            <ul class="list-column">
              <li v-for="(year, i) in refYear" :class="{ active: year.id === yearId }" :key="i">
                <a href="#" @click="changeYear(year.id)">{{ year.year }}</a>
              </li>
            </ul>
          </div>
          <div class="flex-two-col__right">
            <div class="add-npa-row">
              <v-btn class="v-btn btn-add-category" @click="goToCreate">
                {{ $t('Добавить норматив') }}
              </v-btn>
            </div>
          </div>
        </div>
        <div class="table-overflow">
          <table>
            <thead>
            <tr>
              <td>{{ $t("Вид животного") }}</td>
              <td>{{ $t("Норматив пользования") }} (%)</td>
            </tr>
            </thead>
            <tbody>
              <tr v-for="item in faunas" :key="item.id">
                <td>{{ item.fauna }}</td>
                <td>
                  <router-link :to="{ name: 'quota-usage-standard-edit', params: { id: item.id }}">
                    {{ item.limiting }}
                  </router-link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import Menu from '@/components/quota/Menu'
import { mapMutations } from 'vuex'
import faunaLimit from '@/model/faunaLimit'

export default {
  components: {
    Menu
  },
  data: () => ({
    breadcrumbs: [],
    refYear: [],
    yearId: null,
    faunas: []
  }),
  mounted () {
    this.fetchData()
    this.scrollToTop()
  },
  watch: {
    yearId () {
      this.getUsageStandardByYear()
    }
  },
  methods: {
    ...mapMutations(['setLoading']),
    // получаем данные
    fetchData () {
      this.setLoading(true)
      faunaLimit.getUsageStandarFilterFormData()
        .then((res) => {
          this.refYear = res.data.refYears
          const currentYear = new Date().getFullYear()
          this.refYear.forEach((e) => {
            if (+e.year === currentYear) this.yearId = e.id
          })
          this.generateBreadcrumbs()
          this.setLoading(false)
        })
        .catch((err) => {
          console.log(err)
          this.setLoading(false)
        })
    },
    // получаем список по году
    getUsageStandardByYear () {
      this.setLoading(true)
      faunaLimit.getUsageStandardList(this.yearId)
        .then((res) => {
          this.faunas = res.data.items
          this.setLoading(false)
        })
        .catch((err) => {
          console.log(err)
          this.setLoading(false)
        })
    },
    // при смене года, меняем id
    changeYear (id) {
      this.yearId = id
    },
    // генерация хлебных крошек
    generateBreadcrumbs () {
      this.breadcrumbs = [
        {
          text: this.$i18n.t('Главная'),
          disabled: false,
          href: '/'
        },
        {
          text: this.$i18n.t('Рабочий кабинет'),
          disabled: false,
          href: '/my-organization'
        },
        {
          text: this.$i18n.t('Нормативы пользования'),
          disabled: true
        }
      ]
    },
    // Переход на страницу создания
    goToCreate () {
      this.$router.push({
        name: 'quota-usage-standard-create'
      })
    },
    // Прокручивание к началу страницы
    scrollToTop () {
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style scoped>

</style>
